'use client';

import React from 'react';
import { useDashboard } from '@/components/dashboard/DashboardContext';
import { Channel } from '../../../types';
import { 
  Hash, 
  Volume2, 
  Lock 
} from 'lucide-react';
import { cn } from '@/lib/utils';

interface ChannelItemProps {
  channel: Channel;
  isSelected: boolean;
  onClick: () => void;
}

const ChannelItem: React.FC<ChannelItemProps> = ({ channel, isSelected, onClick }) => {
  const { closeSidebar } = useDashboard();

  // 권한 확인 (예시용으로 단순화함)
  const hasPermission = true; // 실제로는 권한을 확인하는 로직 필요

  // 채널 아이콘 선택
  const getChannelIcon = () => {
    if (channel.type.toLowerCase() === 'voice') {
      return <Volume2 className="h-4 w-4 shrink-0 text-foreground dark:text-foreground" />;
    }
    return <Hash className="h-4 w-4 shrink-0 text-foreground dark:text-foreground" />;
  };

  // 채널 선택 시 사이드바 닫기
  const handleSelectChannel = () => {
    onClick();
    closeSidebar();
  };

  return (
    <button
      onClick={handleSelectChannel}
      disabled={!hasPermission}
      className={cn(
        "flex items-center w-full px-2 py-1.5 text-sm rounded-md transition-colors gap-2",
        isSelected 
          ? "bg-[var(--selected-item)] text-[var(--selected-item-text)]" 
          : "text-foreground dark:text-foreground hover:!bg-[var(--hover-item)] hover:!text-[var(--selected-item-text)] focus:!bg-[var(--hover-item)] focus:!text-[var(--selected-item-text)]",
        !hasPermission && "opacity-50 cursor-not-allowed",
      )}
    >
      {!hasPermission ? <Lock className="h-4 w-4 shrink-0" /> : getChannelIcon()}
      <span className="truncate">
        {channel.name}
      </span>
    </button>
  );
};

export default ChannelItem;
